import * as React from 'react';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import sandyLoadingAnimationData from './sandy_loading.json';
import { cn } from '@restworld/utils-common';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const CvParsingLoadingState = () => {
  const { t } = useTranslation('onboarding-page');

  return (
    <LoadingStateContainer>
      <Lottie loop animationData={sandyLoadingAnimationData} />
      <LoadingText>{t('cv_loading.reorganizing_work_experiences')}</LoadingText>
    </LoadingStateContainer>
  );
};

const LoadingStateContainer = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn('w-full flex flex-col justify-center items-center py-8 gap-6 px-4 md:px-8', className)}
    {...props}
  />
);

const LoadingText = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn('text-center text-base md:text-lg font-medium text-gray-900 max-w-sm md:max-w-md', className)}
    {...props}
  />
);
